// extracted by mini-css-extract-plugin
export default {"rotatingBar":"Footer_rotatingBar__s9aAd","rotateColors":"Footer_rotateColors__4eO4F"};